let showOverlayFn: (() => void) | null = null;

export function registerUpdateOverlayService(fn: (() => void) | null) {
  showOverlayFn = fn;
}

export function showUpdateOverlayOutsideReact(): boolean {
  if (showOverlayFn) {
    showOverlayFn();
    return true;
  }
  return false;
}
